const creatorStorageKey = "shuni-creator-token-v1";

export function readStoredCreatorToken() {
  return localStorage.getItem(creatorStorageKey) ?? "";
}

export function rememberCreatorToken(token: string) {
  if (token) localStorage.setItem(creatorStorageKey, token);
}

export function forgetCreatorToken() {
  localStorage.removeItem(creatorStorageKey);
}
